import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import BrandServices from './brand_services';

export const CreateBrand = createAsyncThunk(
  'brand/create_brand',
  async (requestData, thunkAPI) => {
    try {
      const delivered = await BrandServices.CreateBrand(requestData);

      return delivered;
    } catch (e) {
      toast(e.message);
      return thunkAPI.rejectWithValue(e);
    }
  }
);

export const UploadBrandImage = createAsyncThunk(
  'brand/brand_image',
  async (requestData, thunkAPI) => {
    try {
      const delivered = await BrandServices.uploadBrandImage(requestData);

      return delivered;
    } catch (e) {
      toast(e.message);
      console.log('Error', e);
      return thunkAPI.rejectWithValue(e);
    }
  }
);

export const UploadBrandIcon = createAsyncThunk(
  'brand/brand_icon',
  async (requestData, thunkAPI) => {
    try {
      const delivered = await BrandServices.uploadBrandIcon(requestData);

      return delivered;
    } catch (e) {
      toast(e.message);
      console.log('Error', e);
      return thunkAPI.rejectWithValue(e);
    }
  }
);

export const GetAllBrand = createAsyncThunk(
  'brand/get_all_brand',
  async (payload, thunkAPI) => {
    try {
      let response = await BrandServices.getAllBrand(payload);

      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const GetAllMajorBrand = createAsyncThunk(
  'brand/get_all_major_brand',
  async (payload, thunkAPI) => {
    try {
      let response = await BrandServices.getAllMajorBrand();

      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const DeleteBrand = createAsyncThunk(
  'brand/deleteBrand',
  async (payload, thunkAPI) => {
    try {
      let response = await BrandServices.DeleteBrand(payload);

      return response;
    } catch (error) {
      toast(error.message);
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const GetSingleBrandDetails = createAsyncThunk(
  'brand/get_single_brand',
  async (payload, thunkAPI) => {
    try {
      let response = await BrandServices.getSingleBrandDetails(payload);

      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const EditBrandDetail = createAsyncThunk(
  'brand/edit_brand',
  async (requestData, thunkAPI) => {
    try {
      const delivered = await BrandServices.EditBrand(requestData);

      return delivered;
    } catch (e) {
      toast(e.message);
      return thunkAPI.rejectWithValue(e);
    }
  }
);

export const SearchForBrandsByName = createAsyncThunk(
  'brand/searchForBrandsByName',
  async (payload, thunkAPI) => {
    try {
      const delivered = await BrandServices.SearchForBrandByName(payload);

      return delivered;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);
